// ja strings for messages/home.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const home: Dict = {
  "home.seo.title": "Jammable | 好きな声でAIカバーを作成！",
  "home.seo.description":
    "JammableならAIカバーが数秒で作れます。コミュニティが投稿した数千のAIボイスモデルを、今すぐクリエイティブに活用しましょう。",
  "home.seo.ogTitle": "Jammable | 好きな声でAIカバーを作成 | AIで音楽をつくる",
  "home.seo.imageAlt": "Jammable - AIカバーを作成",

  "home.hero.views": "TikTok・YouTube・Instagramで100億回以上再生",
  // "<before> <highlight> <after>": 好きな声で [AIカバー] を作ろう
  "home.hero.titleBefore": "好きな声で",
  "home.hero.titleHighlight": "AIカバー",
  "home.hero.titleAfter": "を作ろう",
  "home.hero.subtitle":
    "10万以上のAIボイスから選んで音声を追加するだけ。数秒で仕上がります。",
  "home.hero.decorVoice": "AIボイス",
  "home.hero.decorCover": "カバー",
  "home.hero.searchLabel": "ボイスを検索",
  "home.hero.searchPlaceholder": "10万以上のボイスを検索",
  "home.hero.searchButton": "検索",
  "home.hero.makeCover": "カバーを作成",

  "home.categories.all": "すべてのカテゴリを見る",
  "home.recent": "続きから",
  "home.trending": "いま話題",
  "home.seeAll": "すべて見る",

  "home.train.kicker": "10万以上のボイスがここから生まれました",
  // "<before> <highlight>": 自分だけの [AIボイスを作ろう]
  "home.train.titleBefore": "自分だけの",
  "home.train.titleHighlight": "AIボイスを作ろう",
  "home.train.body":
    "少しのサンプルからボイスを作って、ほかの誰も持っていない声でカバーを作りましょう。",
  "home.train.step1": "サンプルをアップロード",
  "home.train.step1Sub": "クリアな歌声の短いクリップがあれば十分です",
  "home.train.step2": "モデルを学習",
  "home.train.step2Sub": "数分であなただけのボイスが完成します",
  "home.train.step3": "そのボイスでカバーを作成",
  "home.train.step3Sub": "いつでも好きなときにカバーに使えます",

  "home.topCollections": "人気のコレクション",
  "home.collabs": "話題のコラボ",
  "home.collection": "コレクション",

  "home.card.uses": "{n}回使用",
  "home.card.voices": "{n}ボイス",
  "home.card.likes": "{n}いいね",
  "home.card.by": "@{user}",
  "home.card.madeToday": "今日{n}曲作成",
  "home.card.makeDuet": "このデュエットを作る",

  "home.discord.bannerSub":
    "カバーをシェアしたり、ボイスをリクエストしたり、コミュニティに質問したりできます",
  "home.discord.online": "{n}人がオンライン",
  "home.discord.members": "{n}人のメンバー",
  "home.discord.joinDiscord": "Discordに参加",
  "home.discord.softSub": "カバーのシェア、ボイスのリクエスト、コツの共有",
  "home.discord.cardSub": "質問、カバーのシェア、新しいボイス探し",
  "home.discord.join": "参加",
};

export default home;
